<template>
  <el-drawer
    title="详情"
    :visible.sync="visible"
    direction="rtl"
    :before-close="handleClose"
    custom-class="c-drawer"
    :wrapperClosable="false"
    size="45%"
  >
    <!--操作-->
    <div class="drawer-content">
      <el-form
        ref="formRef"
        :model="info"
        label-width="120px"
        label-position="right"
        size="small"
        v-loading="loading"
        :rules="formRules"
      >
        <el-col :span="12">
          <el-form-item label="code" prop="code">
            <el-input
              v-model="info.code"
              placeholder="code"
              clearable
              :disabled="codeDisabled"
            ></el-input>
            <!--描述-->
            <div class="form-item-desc">
              <span>code是唯一的，不允许重复</span>
              <span>A0001 原厂电池折扣</span>
              <span>A0002 原厂屏幕折扣</span>
              <span>A0003 三方电池折扣</span>
              <span>A0004 三方屏幕折扣</span>
              <span>B开头的且为数字的权益 优惠券相关权益</span>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="名称" prop="name">
            <el-input
              v-model="info.name"
              placeholder="名称"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="激活的Icon" prop="activeIcon">
            <el-input
              v-model="info.activeIcon"
              placeholder="权益icon URL"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="未激活的Icon" prop="inactiveIcon">
            <el-input
              v-model="info.inactiveIcon"
              placeholder="权益icon URL"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="权益Value" prop="value">
            <el-input
              type="textarea"
              v-model="info.value"
              placeholder="权益Value"
              clearable
            ></el-input>
            <div class="form-item-desc">
              <span>权益折扣则为数值，0.8=8折</span>
              <span>优惠券则为优惠券ID</span>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="权益数量" prop="quantity">
            <el-input
              type="number"
              v-model="info.quantity"
              placeholder="权益数量"
              clearable
              min="0"
              max="100000"
            ></el-input>
            <div class="form-item-desc">
              <span>折扣权益则是，折扣次数</span>
              <span>优惠券权益则是，送N张优惠券</span>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="权益描述" prop="description">
            <el-input
              type="textarea"
              v-model="info.description"
              placeholder="权益描述"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form>

      <!--table-->
      <div class="title">
        折扣定价
      </div>
      <div class="btns">
        <div class="rl">
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="addDiscount"
            >添加</el-button
          >
        </div>
      </div>
      <el-table
        :data="discountTable"
        style="width: 100%"
        border
        size="mini"
        v-loading="tableLoading"
      >
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="name" label="折扣名称"></el-table-column>
        <el-table-column prop="begin" label="开始区间"></el-table-column>
        <el-table-column prop="end" label="结束区间"></el-table-column>
        <el-table-column prop="discount" label="折扣"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-link
              type="primary"
              :underline="false"
              size="mini"
              @click="handleEditDiscount(scope.row)"
              >编辑</el-link
            >
            <el-divider direction="vertical"></el-divider>
            <el-link
              type="danger"
              :underline="false"
              size="mini"
              @click="handleDeleteDiscount(scope.row)"
              >删除</el-link
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.pageNum"
        :page-sizes="[10, 20, 50]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchForm.total"
      >
      </el-pagination>
    </div>

    <div class="editOpera-seat"></div>
    <div class="drawer-footer">
      <div class="operation">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </div>
    </div>

    <privilege-discount
      ref="discountRef"
      @refresh="loadPrivilegeDiscount"
    ></privilege-discount>
  </el-drawer>
</template>
<script>
import PrivilegeDiscount from "./discount";
import {
  bizPrivilegePoolsSave,
  bizPrivilegeCodeExist,
  bizPrivilegePoolsInfo,
  bizPrivilegeDiscountPage,
  bizPrivilegeDiscountDelete
} from "@/api/privilege";
export default {
  name: "bizPrivilegePoolInfo",
  data() {
    var codeValidator = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入code"));
      }
      // 不允许的code
      bizPrivilegeCodeExist(value, this.info.id).then(resp => {
        if (resp.data.status == 100) {
          callback();
        } else {
          callback(new Error(resp.data.message));
        }
      });
    };
    return {
      info: {},
      visible: false,
      loading: false,
      formRules: {
        code: [
          { required: true, message: "请输入code", trigger: "blur" },
          { validator: codeValidator, trigger: "blur" }
        ],
        name: [{ required: true, message: "请输入名称", trigger: "blur" }]
      },
      discountTable: [],
      tableLoading: false,
      searchForm: {
        total: 0,
        pageSize: 10,
        pageNum: 1
      }
    };
  },
  components: {
    PrivilegeDiscount
  },
  computed: {
    codeDisabled() {
      return !!this.info.id;
    }
  },
  methods: {
    open(info) {
      this.info = info || {};
      this.visible = true;
      if (this.info.id) {
        this.loadPrivilegeDiscount();
      }
    },
    handleClose() {
      this.visible = false;
      this.$refs.formRef.resetFields();
      this.info = {};
    },
    handleConfirm() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          this.saveFormData();
        }
      });
    },
    saveFormData() {
      this.loading = true;
      bizPrivilegePoolsSave(this.info)
        .then(resp => {
          if (resp.data.status == 100) {
            this.$message({
              message: "保存成功",
              type: "success"
            });
            // this.handleClose();
            this.loadPrivilege();
            this.$emit("refresh");
          } else {
            this.$message({
              message: resp.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadPrivilege() {
      this.loading = true;
      bizPrivilegePoolsInfo(this.info.id).then(resp => {
        if (resp.data.status == 100) {
          this.info = resp.data.results;
        }
      });
    },
    /**
     * 查询折扣
     */
    loadPrivilegeDiscount(page) {
      if (page) {
        this.searchForm.pageNum = page;
      }
      this.searchForm.privilegeId = this.info.id;
      this.tableLoading = true;
      bizPrivilegeDiscountPage(this.searchForm)
        .then(resp => {
          this.tableLoading = false;
          if (resp.data.status == 100) {
            this.discountTable = resp.data.results.list;
            this.searchForm.total = resp.data.results.total;
          } else {
            this.$message({
              message: resp.data.message,
              type: "warning"
            });
          }
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.loadPrivilegeDiscount();
    },
    handleCurrentChange(page) {
      this.searchForm.pageNum = page;
      this.loadPrivilegeDiscount();
    },
    addDiscount() {
      const { id, code } = this.info;
      if (!id) {
        this.$message({
          message: "请先保存",
          type: "warning"
        });
        return;
      }
      const discountInfo = {
        privilegeId: id,
        privilegeCode: code,
        privilegeName: this.info.name
      };
      this.$refs.discountRef.open(discountInfo);
    },
    handleEditDiscount(row) {
      const discountInfo = {
        ...row,
        privilegeId: this.info.id,
        privilegeCode: this.info.code,
        privilegeName: this.info.name
      };
      this.$refs.discountRef.open(discountInfo);
    },
    handleDeleteDiscount(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定"
      })
        .then(() => {
          this.tableLoading = true;
          bizPrivilegeDiscountDelete(row.id)
            .then(resp => {
              if (resp.data.status == 100) {
                this.$message({
                  message: "删除成功"
                });
                this.loadPrivilegeDiscount();
              } else {
                this.$message({
                  message: resp.data.message,
                  type: "error"
                });
              }
            })
            .finally(() => {
              this.tableLoading = false;
            });
        })
        .catch(() => {});
    }
  }
};
</script>
<style>
.c-drawer .el-drawer__body {
  overflow: auto;
  padding: 24px;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;
  word-break: break-all;
  overflow: auto;
}
</style>
<style lang="scss" scoped>
.c-drawer {
  .drawer-content {
    //距离bottom
    .editor {
      height: 300px;
      margin-bottom: 100px;
    }
    .explain {
      font-size: 12px;
      color: #999;
      margin-top: 8px;
      line-height: 1.5;
    }
  }
  .editOpera-seat {
    width: 100%;
    height: 54px;
  }
  .drawer-footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    left: 0;
    background: #fff;
    border-radius: 0 0 4px 4px;
    z-index: 30;
    display: flex;
    /** 操作 靠右 */
    .operation {
      margin-left: auto;
      display: flex;
    }
  }
}
.title {
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 10px;
}
.btns {
  text-align: right;
  margin: 10px 0;
  .rl {
    margin-left: auto;
  }
}
.form-item-desc {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
  line-height: 1.5;
  span {
    padding: 0 5px;
  }
}
</style>



// WEBPACK FOOTER //
// info.vue?23aa6f54